import React, { useEffect, useState } from "react";
import { Col } from "react-bootstrap";
import apiClient from "../Config/apiConfig";
import OwlCarousel from "react-owl-carousel";
import { LineWave } from "react-loader-spinner";
const config = {
    BASE_URL: "https://admin.thezeeshangroup.com/",
};
const Ourpartner = () => {
    const [getPartnerData, setGetPartnerData] = useState([]);
    const [loader, setLoader] = useState(true);
    const partnerApi = async () => {
        try {
            const res = await apiClient.get(`api/our-partners`);
            setLoader(true);
            setGetPartnerData(res.data);
            setLoader(false);
        } catch (error) {
            console.log(error.message);
        }
    };
    useEffect(() => {
        partnerApi();
    }, []);
    const clients = {
        margin: 20,
        responsiveClass: true,
        nav: false,
        autoplay: true,
        loop: true,
        dots: true,
        // smartSpeed: 1000,
        autoplayTimeout: 3000,
        autoplaySpeed: 3000,
        responsive: {
            0: {
                items: 2,
            },
            400: {
                items: 2,
            },
            600: {
                items: 3,
            },
            700: {
                items: 4,
            },
            1000: {
                items: 6,
            },
        },
    };
    return (
        <>
            <Col sm="12">
                {loader ? (
                    <div className="d-flex justify-content-center">
                        <LineWave
                            height="250"
                            width="150"
                            color="#56b13d"
                            ariaLabel="line-wave"
                        />
                    </div>
                ) : (
                    <OwlCarousel
                        className="slider-items owl-carousel partner-logo"
                        {...clients}
                    >
                        {getPartnerData.map((item, i) => {
                            return (
                                <>
                                    <div className="item">
                                        <img src={`${config.BASE_URL}uploads/ourpartner/${item.image}`} alt={`Our Partners ${i}`} />
                                    </div>
                                </>

                            );
                        })}
                    </OwlCarousel>
                )}
            </Col>
        </>
    );
};

export default Ourpartner;
